<template>
  <j-modal :title="title" :width="800" :visible="visible" :confirmLoading="confirmLoading" :maskClosable="false"
    :body-style="{ height: '480px', overflow: 'hidden', overflowY: 'scroll' }" @ok="handleOk" @cancel="handleCancel"
    :okText="$t('确定')" :cancelText="$t('关闭')" :okButtonProps="{ class:{'jee-hidden': disableSubmit} }">
    <a-spin :spinning="confirmLoading">
      <div>
        <div style="display: flex;">
          <div style="flex: 1;">
            <detail-list :col="1">
              <detail-list-item :term="$t('证件姓名')">{{userInfo.name}}</detail-list-item>
              <!-- <detail-list-item term="证件类型">{{userInfo.type}}</detail-list-item> -->
              <detail-list-item :term="$t('证件号码')">{{userInfo.number}}</detail-list-item>
              <detail-list-item :term="$t('地址')">{{userInfo.address}}</detail-list-item>
              <detail-list-item :term="$t('性别')" :itemCol="1">{{userInfo.sex}}</detail-list-item>
              <detail-list-item :term="$t('名族')" :itemCol="1">{{userInfo.nation}}</detail-list-item>
              <detail-list-item :term="$t('出生日期')" :itemCol="1">{{userInfo.birth}}</detail-list-item>
              <detail-list-item :term="$t('签发机关')" :itemCol="1">{{userInfo.organization}}</detail-list-item>
              <detail-list-item :term="$t('有效期起始')">{{userInfo.dateStart}}</detail-list-item>
              <detail-list-item :term="$t('有效期终止')">{{userInfo.dateEnd}}</detail-list-item>
            </detail-list>
          </div>
          <div style="width: 200px;height: 250px;border:1px solid #eee;display: flex;align-items: center;justify-content: center;">
            <img :src="headImg" alt="" style="width: 100%;height: 100%;" v-if="headImg" />
            <div v-else><em>{{ $t('暂无头像') }}</em></div>
          </div>
        </div>
        <div style="display: flex;justify-content: center;">
          <a-button type="primary" @click="readIDCard">
              {{ $t('读身份证') }}
          </a-button>
        </div>
      </div>
    </a-spin>
  </j-modal>
</template>

<script>
  import {
    httpAction,
    getAction
  } from '@/api/manage'
  import DetailList from '@/components/tools/DetailList'
  const DetailListItem = DetailList.Item
  import Vue from 'vue'
  export default {
    name: 'readIDCardModal',
    components: {
      DetailList,
      DetailListItem,
    },
    data() {
      return {
        title: '',
        width: 800,
        visible: false,
        disableSubmit: false,
        confirmLoading: false,
        userInfo: {},
        headImg: ''
      }
    },
    methods: {
      init(row) {
        this.title = this.$t('读取身份证信息');
        this.visible = true;
        this.userInfo = {};
        this.headImg = '';
        this.initWebSocket();
      },
      handleOk() {
        this.$emit('ok', this.userInfo);
        this.close();
      },
      close() {
        this.$emit('close');
        this.visible = false;
      },
      handleCancel() {
        this.close()
      },
      readIDCard(){
        this.$message.success(this.$t('读取身份证信息中，请稍等！'))
        let json = {"Type":"4","Method":"star_ReadIdInfo","nPort":"0","nBaud":"9600","cBp":"0","szBmpPath":"D:\\test1.bmp","nTimeout":"10"};//二代身份证
        this.websocketSend(JSON.stringify(json));
      },
      // websocket消息通知开始
      initWebSocket() {
        // WebSocket与普通的请求所用协议有所不同，ws等同于http，wss等同于https
        var userId = this.$store.getters.userInfo.id;
        // var url = window._CONFIG['domianURL'].replace("https://", "wss://").replace("http://", "ws://") + "/websocket/" + userId;
        // var url = 'http://172.16.8.137:19998/'
        var url = 'http://127.0.0.1:19998/'

        //update-begin-author:taoyan date:2022-4-22 for:  v2.4.6 的 websocket 服务端，存在性能和安全问题。 #3278
        let token = Vue.ls.get('ACCESS_TOKEN')

        this.websocket = new WebSocket(url);
        //update-end-author:taoyan date:2022-4-22 for:  v2.4.6 的 websocket 服务端，存在性能和安全问题。 #3278
        this.websocket.onopen = this.websocketOnopen;
        this.websocket.onerror = this.websocketOnerror;
        this.websocket.onmessage = this.websocketOnmessage;
        this.websocket.onclose = this.websocketOnclose;
      },
      websocketOnopen() {
        console.log("WebSocket消息通知layout连接成功");
        //心跳检测重置
        // this.heartCheck.reset().start();
      },
      websocketOnerror(e) {
        console.log("WebSocket连接发生错误，第%s次", this.wsConnectErrorTime);

        this.wsConnectErrorTime = this.wsConnectErrorTime + 1;
        if (this.wsConnectErrorTime > 5) {
          console.log("WebSocket连接错误超过5次，就不再重新连了！");
          this.lockReconnect = true
          return;
        }
        // this.reconnect();
      },
      websocketOnmessage(e) {
        let data = JSON.parse(e.data); //解析json字符串
        console.log("WebSocket消息通知layout收到消息", data);
        // 按照实际需求处理消息（即只推送给含有特定消息类型的用户）
        // if(this.messageType.findIndex(item => item == data.port) == -1) {
        //   return
        // }
        console.log(data);
        if (data.Type == 4 && data.Method == "star_ReadIdInfo") { // 身份证识别结果
          if(data.ret == 0){
            // 二代身份证
            var szIdInfo = data.szIdInfo;
            var infoList = szIdInfo.split('|');
            this.userInfo = {
              name: infoList[0],
              type: infoList[9],
              number: infoList[5],
              address: infoList[4],
              sex: infoList[1],
              nation: infoList[2],
              organization: infoList[6],
              birth: infoList[3],
              dateStart: infoList[7],
              dateEnd: infoList[8],
            }
            this.headImg = "data:image/png; base64," + data.szPhotoBase64;
          }else{
            this.$message.warning(this.$t('请将身份证放置在仪器上识别！'))
          }
        }
      },
      websocketOnclose(e) {
        console.log("connection closed (" + e + ")");
        if (e) {
          console.log("connection closed (" + e.code + ")");
        }
        // this.reconnect();
      },
      websocketSend(text) { // 数据发送
        try {
          this.websocket.send(text);
        } catch (err) {
          console.log("send failed (" + err.code + ")");
        }
      },
    }
  }
</script>
<style scoped>
  /deep/.detail-list .content {
    line-height: normal;
  }
</style>